import { render, staticRenderFns } from "./SatisTalebiForm.vue?vue&type=template&id=107e2c05&scoped=true"
import script from "./SatisTalebiForm.vue?vue&type=script&lang=ts"
export * from "./SatisTalebiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107e2c05",
  null
  
)

export default component.exports